module.exports = __webpack_public_path__ + "img/prize-03.f3f770d3.png";